module.exports = __webpack_public_path__ + "static/img/c-wd.b2b567d5.png";